<template>
       <span style="font-size: 1.2em;font-weight: bold">
          Competência - {{labelCompetencia}} -
          <span class="badge badge-pill"
                :class="{ 'badge-success' : isOpen , 'badge-dark' : !isOpen}">  {{labelStatus}} </span>
          </span>
</template>

<script>
  import {competenciaStatusLabel, competenciaIsOpen} from '@/domain/utils'

  export default {
    name: "TitleHeader",
    props :[ 'ano' , 'mes' , 'status'],
    computed: {
      labelCompetencia() {
        return  `${this.ano}/${this.mes}`
      },
      labelStatus() {
        return competenciaStatusLabel(this.status)
      },
      isOpen() {
        return competenciaIsOpen(this.status)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/TitleHeader.vue